
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitonagpurcab() {



    const cardData =
    {
        keyword: ' Mumbai to Nagpur Cab ',
        heading: 'Deva Cabs: Mumbai to Nagpur Cab ',
        headingDescription: 'Deva Cabs offers reliable and comfortable cab services from Mumbai to Nagpur, making your long-distance travel across Maharashtra smooth and stress-free. Covering approximately 820 km, the journey takes you through diverse landscapes, and our Sedans, SUVs, and Innova Crysta ensure a safe and enjoyable ride for individuals, families, and groups. Whether you are heading to Nagpur for business, family functions, or to explore attractions like the Zero Mile Stone, Futala Lake, Sitabuldi Fort, and Deekshabhoomi, our cabs provide the perfect balance of comfort and affordability.',

        top: 'Top Places to Visit in Nagpur with Deva Cabs',

"topPlaces": [
  {
    "title": "Deekshabhoomi",
    "location": "Nagpur, Maharashtra",
    "description": "A national monument of social justice, Deekshabhoomi marks the site where Dr. B. R. Ambedkar embraced Buddhism with his followers in 1956. The grand stupa, modeled on Sanchi, attracts pilgrims and tourists alike. Its serene ambiance, library, and landscaped gardens make it not only a spiritual landmark but also a symbol of equality and transformation in modern India."
  },
  {
    "title": "Zero Mile Stone",
    "location": "Civil Lines, Nagpur, Maharashtra",
    "description": "This historic sandstone pillar, erected in 1907, is believed to represent the geographical center of colonial India. Surrounded by four stone horses, it has become a symbolic reference point for Nagpur’s identity as the ‘Heart of India’. A short stop here connects travelers to the city’s colonial heritage and enduring geographical significance."
  },
  {
    "title": "Futala Lake",
    "location": "Futala, Nagpur, Maharashtra",
    "description": "Spread over 60 acres, this picturesque lake is known for its landscaped banks, colorful fountains, and evening street-food culture. Originally built by the Bhosle rulers over 200 years ago, Futala is now Nagpur’s favorite hangout spot. Sunset views, horse-cart rides, and leisure walks around the water make it an essential stop for families and couples."
  },
  {
    "title": "Sitabuldi Fort",
    "location": "Sitabuldi, Nagpur, Maharashtra",
    "description": "Perched on a hill in central Nagpur, this 19th-century British fort witnessed the Battle of Sitabuldi in 1817. Though under military control today, it opens to visitors on special days, offering sweeping views of the city. Its bastions, underground passages, and historical plaques narrate Nagpur’s colonial past and Maratha resistance."
  },
  {
    "title": "Ambazari Lake & Garden",
    "location": "Ambazari, Nagpur, Maharashtra",
    "description": "The largest of Nagpur’s lakes, Ambazari is surrounded by lush greenery and an adjoining garden developed by the Nagpur Municipal Corporation. With jogging tracks, boating facilities, and open-air musical fountains, it is perfect for family outings. Migratory birds add to the charm during winter months, making it a blend of leisure and nature."
  },
  {
    "title": "Nagpur Central Museum (Ajab Bangla)",
    "location": "Civil Lines, Nagpur, Maharashtra",
    "description": "Founded in 1863, this is one of the oldest museums in India, housing rare artifacts from the Satavahana, Vakataka, and Gond dynasties. Exhibits include ancient sculptures, manuscripts, coins, and tribal handicrafts. The Indo-Saracenic building itself is a heritage attraction, often referred to as ‘Ajab Bangla’ by locals."
  },
  {
    "title": "Raman Science Centre & Planetarium",
    "location": "Gandhi Sagar, Nagpur, Maharashtra",
    "description": "An interactive science museum named after Nobel laureate C. V. Raman, it inspires young minds with hands-on exhibits. The planetarium shows, 3D films, and innovation galleries make it a popular educational destination. Its central location makes it easily accessible for school groups and curious travelers alike."
  },
  {
    "title": "Dragon Palace Temple",
    "location": "Kamptee, Nagpur District, Maharashtra",
    "description": "Known as the ‘Lotus Temple of Nagpur’, this Japanese-style Buddhist temple is set amidst manicured gardens. Its pristine white structure houses a massive idol of Buddha, exuding peace and harmony. The temple’s Indo-Japanese collaboration reflects Nagpur’s spiritual inclusivity and attracts both devotees and architecture enthusiasts."
  },
  {
    "title": "Gorewada Lake & Zoo",
    "location": "Gorewada, Nagpur, Maharashtra",
    "description": "Situated in a forested area, Gorewada Lake supplies drinking water to the city while doubling as a serene picnic spot. The adjoining Gorewada International Zoo project showcases Indian and African wildlife in open enclosures. Visitors can enjoy safaris, bird-watching, and tranquil lakeside walks."
  },
  {
    "title": "Balaji Mandir (Seminary Hills)",
    "location": "Seminary Hills, Nagpur, Maharashtra",
    "description": "Perched atop the lush Seminary Hills, this temple dedicated to Lord Balaji is both a religious and scenic attraction. The climb offers panoramic views of Nagpur city, especially during sunrise and sunset. The tranquil environment and proximity to nature make it a rejuvenating escape within city limits."
  }
],



"services": [
  {
    "name": "Mumbai to Nagpur Cab",
    "description": "Travel comfortably with Deva Cabs’ Mumbai to Nagpur cab service. Whether it’s for business, family visits, or long-distance travel, our well-maintained AC cabs ensure a safe and reliable journey across Maharashtra. Enjoy seamless travel with expert drivers and flexible pickup options."
  },
  {
    "name": "Mumbai to Nagpur taxi service",
    "description": "Choose Deva Cabs for dependable Mumbai to Nagpur taxi services. Our fleet includes hatchbacks, sedans, SUVs, and tempo travellers to suit all travel needs—perfect for solo, family, or group travel over long distances."
  },
  {
    "name": "Mumbai to Nagpur one way cab",
    "description": "Book a one-way cab from Mumbai to Nagpur with Deva Cabs for affordable and convenient travel. Ideal for travelers who do not need a return trip, our one-way service offers flexible timings and cost-effective pricing with no hidden charges."
  },
  {
    "name": "Mumbai to Nagpur round trip cab",
    "description": "Planning a round trip? Deva Cabs offers Mumbai to Nagpur round trip cab services with waiting time included and return flexibility. Perfect for business visits or weekend trips requiring same or next-day return."
  },
  {
    "name": "Affordable Mumbai to Nagpur cab",
    "description": "Deva Cabs provides budget-friendly cab options for the Mumbai to Nagpur route. Get quality service, trained drivers, and clean vehicles at economical rates—perfect for frequent travelers and families."
  },
  {
    "name": "Mumbai to Nagpur car rental",
    "description": "Rent a car for your Mumbai to Nagpur journey with Deva Cabs. Choose from daily, weekly, or monthly packages with or without a driver. Great for flexible itineraries and long stays in Nagpur."
  },
  {
    "name": "Mumbai to Nagpur outstation cab",
    "description": "Our outstation cabs from Mumbai to Nagpur are ideal for travelers looking for comfort and reliability on long-distance routes. Enjoy GPS-enabled cabs, verified drivers, and 24/7 customer support."
  },
  {
    "name": "Book Mumbai to Nagpur cab online",
    "description": "Easily book your Mumbai to Nagpur taxi online through our user-friendly platform. Enjoy instant confirmation, upfront pricing, and multiple vehicle options—all just a few clicks away."
  },
  {
    "name": "Mumbai to Nagpur chauffeur cab",
    "description": "Experience premium service with our chauffeur-driven cabs from Mumbai to Nagpur. Our experienced drivers ensure a smooth and safe ride, perfect for business executives or elderly passengers."
  },
  {
    "name": "Mumbai to Nagpur sedan taxi",
    "description": "For solo travelers or couples, our sedan taxis offer a comfortable and fuel-efficient ride from Mumbai to Nagpur. Book sedans like Dzire or Etios for a relaxed and affordable journey."
  },
  {
    "name": "Mumbai to Nagpur SUV cab",
    "description": "Travel in style and comfort with our SUV cabs from Mumbai to Nagpur. Spacious and powerful, our SUVs are perfect for families, groups, or travelers with extra luggage."
  },
  {
    "name": "Mumbai to Nagpur tempo traveller",
    "description": "Need more space? Hire a tempo traveller from Mumbai to Nagpur for group travel. Ideal for family functions, corporate trips, or educational tours, with seating for up to 12+ passengers."
  },
  {
    "name": "Mumbai to Nagpur luxury cab",
    "description": "Choose our luxury cab service from Mumbai to Nagpur for a high-end travel experience. Enjoy top-tier vehicles like Innova Crysta or premium sedans with plush interiors and professional chauffeurs."
  },
  {
    "name": "Budget cab Mumbai to Nagpur",
    "description": "On a tight budget? Our budget cab service from Mumbai to Nagpur offers reliable vehicles at pocket-friendly rates, without compromising on safety or comfort."
  },
  {
    "name": "Mumbai airport to Nagpur cab",
    "description": "Arriving at Mumbai Airport? Book a cab directly from the airport to Nagpur with Deva Cabs. Our drivers ensure timely pickups, comfortable rides, and assistance with luggage."
  },
  {
    "name": "Premium cab Mumbai to Nagpur",
    "description": "Upgrade your travel with Deva Cabs’ premium cab service from Mumbai to Nagpur. Ideal for VIPs, business travelers, or special occasions, with high-end cars and experienced chauffeurs."
  },
  {
    "name": "Family cab Mumbai to Nagpur",
    "description": "Travel with family in safety and comfort in our family-friendly cabs. Spacious, sanitized, and equipped with AC, our cabs make your Mumbai to Nagpur journey stress-free and enjoyable."
  },
  {
    "name": "Mumbai to Nagpur cab for travel",
    "description": "Whether for leisure, work, or relocation, Deva Cabs provides dependable Mumbai to Nagpur cab services for all travel purposes. Get smooth service from booking to drop-off."
  }
],
"tableData": [
  ["Mumbai to Nagpur Cab", "-Mumbai to Nagpur taxi service"],
  ["Mumbai to Nagpur one way cab", "-Mumbai to Nagpur round trip cab"],
  ["Affordable Mumbai to Nagpur cab", "-Budget cab Mumbai to Nagpur"],
  ["Mumbai to Nagpur car rental", "-Mumbai to Nagpur outstation cab"],
  ["Book Mumbai to Nagpur cab online", "-Mumbai to Nagpur chauffeur cab"],
  ["Mumbai to Nagpur sedan taxi", "-Mumbai to Nagpur SUV cab"],
  ["Mumbai to Nagpur tempo traveller", "-Mumbai to Nagpur luxury cab"],
  ["Mumbai airport to Nagpur cab", "-Premium cab Mumbai to Nagpur"],
  ["Family cab Mumbai to Nagpur", "-Mumbai to Nagpur cab for travel"]
],

"whychoose": [
  {
    "WhyChooseheading": "Reliable Mumbai to Nagpur Cab Service",
    "WhyChoosedescription": "Travel the 800+ km stretch from Mumbai to Nagpur with confidence in Deva Cabs’ reliable long-distance cab service. Ideal for business trips, family visits, or tourism, our service ensures a smooth, safe, and timely journey across Maharashtra."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for All Needs",
    "WhyChoosedescription": "From economy sedans and SUVs to spacious tempo travellers, we offer a vehicle for every kind of traveler. Whether you're going solo, with family, or in a group, our fleet is well-maintained, air-conditioned, and road-trip ready."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Long-Distance Expertise",
    "WhyChoosedescription": "Our drivers are trained for long-haul travel and familiar with the Mumbai–Nagpur highway route. They prioritize passenger safety, maintain steady speeds, and offer comfort stops along the way for a relaxed and stress-free journey."
  },
  {
    "WhyChooseheading": "One-Way, Round Trip & Custom Packages",
    "WhyChoosedescription": "Choose from flexible packages including one-way drops, round trips, or multi-stop routes. Whether you're planning a same-day return or a few days’ stay in Nagpur, we tailor the cab service to fit your schedule and budget."
  },
  {
    "WhyChooseheading": "Transparent and Fixed Pricing",
    "WhyChoosedescription": "With Deva Cabs, what you see is what you pay. Our fares are inclusive of fuel, tolls, parking, and driver allowance—no hidden fees or surprise costs. You get clear billing with upfront confirmation."
  },
  {
    "WhyChooseheading": "24/7 Availability and Emergency Support",
    "WhyChoosedescription": "Late-night travel or early morning departure? Our Mumbai to Nagpur cabs operate round-the-clock, with customer support always on standby. Get assistance before, during, or after your journey—anytime you need it."
  },
  {
    "WhyChooseheading": "Simple Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your cab through our website or support team with just a few clicks. Get immediate confirmation, transparent fare breakdown, and driver details sent to your phone or email—no waiting or uncertainty."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and GPS-Enabled Vehicles",
    "WhyChoosedescription": "Your safety and comfort come first. All cabs are sanitized before every trip, equipped with GPS tracking, seat belts, and emergency kits—ensuring a secure and hygienic experience over the long-distance Mumbai–Nagpur route."
  }
]














    }



const faqData = [
  {
    question: "Can I book a cab from Mumbai to Nagpur with Deva Cabs?",
    answer: "Yes, Deva Cabs provides reliable cab services from Mumbai to Nagpur for business, personal, and leisure travel."
  },
  {
    question: "How long does the Mumbai to Nagpur trip take by cab?",
    answer: "The journey usually takes around 13 to 15 hours depending on traffic, weather, and stopovers along the 800+ km route."
  },
  {
    question: "What types of cabs are available for Mumbai to Nagpur?",
    answer: "We offer sedans, SUVs, tempo travellers, and luxury vehicles based on your group size and comfort requirements."
  },
  {
    question: "Do you offer both one-way and round-trip options?",
    answer: "Yes, Deva Cabs offers flexible booking for one-way, round-trip, and even multi-day travel between Mumbai and Nagpur."
  },
  {
    question: "Are tolls, fuel, and driver charges included in the fare?",
    answer: "Our pricing is transparent. The fare includes fuel and driver allowance, while tolls and parking are usually extra and communicated clearly during booking."
  },
  {
    question: "Is this long-distance service available 24/7?",
    answer: "Yes, Deva Cabs operates 24/7, allowing you to book early morning or late-night departures to suit your travel plans."
  },
  {
    question: "Is it safe for senior citizens and children?",
    answer: "Absolutely. Our vehicles are sanitized, seat belts are available for all seats, and our experienced drivers ensure a safe journey for all passengers."
  },
  {
    question: "Can I request stopovers along the way?",
    answer: "Yes, you can request specific stopovers during booking for meals, rest, or sightseeing. Just mention your preferences in advance."
  },
  {
    question: "Do you offer luxury cab options for Mumbai to Nagpur?",
    answer: "Yes, we have premium cars like Innova Crysta and other luxury options for a more comfortable and stylish long-distance journey."
  },
  {
    question: "Why should I choose Deva Cabs for Mumbai to Nagpur travel?",
    answer: "Deva Cabs ensures clean vehicles, experienced drivers, fixed pricing, and 24/7 support for a stress-free long-distance cab experience."
  }
];
const testimonialData = [
  {
    id: 101,
    name: 'Mr. Rajesh Patil',
    role: 'Business Traveler',
    review: 'I booked a one-way cab from Mumbai to Nagpur. The driver was professional and the car was extremely clean. Reached safely and on time.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 102,
    name: 'Ms. Nisha Jagtap',
    role: 'Frequent Commuter',
    review: 'Deva Cabs provided a smooth ride for my Nagpur visit. Very comfortable SUV, great driver, and excellent support throughout the journey.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];




















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Nagpur Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-nagpur-cab.jpg", // Update with actual image URL
  "description": "Book a comfortable Mumbai to Nagpur cab online with Deva Cabs. One-way and round-trip chauffeur-driven taxi services available for long-distance travel. Choose from sedans, SUVs, and tempo travellers.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "180",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11500",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-nagpur-cab" // Update with actual URL
  }
};






    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Nagpur Cab | Book One-Way & Round Trip Taxi Online | Deva Cabs</title>
  <meta
    name="description"
    content="Affordable Mumbai to Nagpur cab service with chauffeur-driven sedans, SUVs, and tempo travellers. Book one-way or round trip taxi online for long-distance travel with Deva Cabs."
  />
  <meta
    name="keywords"
    content="Mumbai to Nagpur Cab, Mumbai to Nagpur taxi service, Mumbai to Nagpur one way cab, Mumbai to Nagpur round trip cab, Affordable Mumbai to Nagpur cab, Mumbai to Nagpur car rental, Book Mumbai to Nagpur cab online, Mumbai to Nagpur SUV cab, Mumbai to Nagpur tempo traveller"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/76.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitonagpurcab;